import { InventoryWidget } from "../../Widgets/InventoryWidget"
export const InventoryManagement = () => {
    return (
        <>
            <InventoryWidget />
        </>
    )
}